export default __webpack_public_path__ + "./fonts/download.db9f1e2f.svg";